import { useIsMobile } from "utils";

import styles from "./RingBackdrop.module.css";

const RingBackdrop = () => {
  const isMobile = useIsMobile();
  const size = isMobile ? 880 : 1024;
  const sizes = [1040, 960, 880, 800, 720];
  const opacities = [0.12, 0.18, 0.24, 0.3, 0.38, 0.46];
  const rotationDeg = isMobile ? 43 : 30;
  const fillColor = "rgba(255,255,255,0.03)";
  const strokeColor = "rgba(218,152,80,0.5)";
  const strokeWidth = 1;

  return (
    <div
      className={styles.container}
      style={{
        width: size,
        height: size,
        transform: `rotate(${rotationDeg}deg)`,
      }}
      aria-hidden
    >
      {sizes.map((d, i) => (
        <div
          key={`${d}-${i}`}
          className={styles.ring}
          style={{
            width: d,
            height: d,
            opacity: opacities[i] ?? opacities[opacities.length - 1],
            backgroundColor: fillColor,
            borderColor: strokeColor,
            borderWidth: strokeWidth,
          }}
        />
      ))}
    </div>
  );
};

export default RingBackdrop;
